var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_414_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4112 0.529053H1.49082C0.823993 0.529053 0.28479 1.0555 0.28479 1.70637V15.6842C0.28479 16.3351 0.823993 16.8647 1.49082 16.8647H15.4112C16.0781 16.8647 16.6205 16.3351 16.6205 15.6874V1.70637C16.6205 1.0555 16.0781 0.529053 15.4112 0.529053ZM5.13124 14.4495H2.70643V6.65173H5.13124V14.4495ZM3.91883 5.5893C3.14034 5.5893 2.5118 4.96075 2.5118 4.18542C2.5118 3.41013 3.14034 2.78159 3.91883 2.78159C4.69416 2.78159 5.32268 3.41013 5.32268 4.18542C5.32268 4.95755 4.69416 5.5893 3.91883 5.5893ZM14.2052 14.4495H11.7836V10.6591C11.7836 9.75615 11.7676 8.59159 10.5233 8.59159C9.26301 8.59159 9.07158 9.57748 9.07158 10.5953V14.4495H6.65315V6.65173H8.97588V7.71739H9.00777C9.33002 7.10481 10.1213 6.45713 11.2986 6.45713C13.7522 6.45713 14.2052 8.07154 14.2052 10.1709V14.4495Z",
    fill: "#262F3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_414_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.3357,
    height: 16.3357,
    fill: "white",
    transform: "translate(0.28479 0.529053)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLk);
export default __webpack_public_path__ + "static/media/lk.3e3e56099c6e81aacd2ddaea8020809a.svg";
export { ForwardRef as ReactComponent };